<template>
    <div class="el-form">
        <div class="el-form__text"
             v-show="type === 'text'">
            <div class="el-form__chars">
                <el-char
                    v-for="(char, index) in value"
                    v-bind:key="index"
                    v-bind:index="addIndex ? String(index) : false"
                    flair="input"
                    v-bind:char="char"></el-char>
            </div>

            <input
                class="el-form__input"
                v-bind:has-input="!!value"
                v-bind:value="value"
                v-on:input="input"
                v-on:keydown="keydown"
                placeholder="Click and type here" />
        </div>

        <div class="el-form__area"
             v-show="type === 'area'">
            <textarea
                class="el-form__textarea"
                v-on:input="input"
                v-bind:value="value"></textarea>

            <button
                v-on:click="submit"
                class="button">Submit</button>
        </div>
    </div>
</template>

<script>
    import ElChar from './el-char.vue';

    export default {
        components : { ElChar },

        methods : {
            input(e) {
                this.$emit('input', e.target.value);
            },

            keydown(e) {
                if (e.key === 'Enter') {
                    this.submit();
                }
            },

            submit() {
                this.$emit('submit');
            }
        },

        props : {
            addIndex : Boolean,
            type : {
                default : 'text',
                validator: (v) => ['text', 'area'].includes(v)
            },
            value : String
        }
    }
</script>